import { Dialog, Icon, Icons, Intent } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import FileUploadInputComponent from "../../components/file/file-upload-input.component";
import SelectCommonSearchInputComponent from "../../components/posm/common-search/common-search-input.component";
import DecimalNumbeInputComponent from "../../components/posm/goods-movement/decimal-number-input.component";
import QtyNumberInputComponent from "../../components/posm/goods-movement/qty-number-input.component";
import SelectUserComponent from "../../components/user/select-user.component";
import { COMMON_SEARCH_DATA_TYPES, formats } from "../../config/constants";
import loginModel from "../../models/login.model";
import { DEFAULT_MAX_QTY } from "../../models/posm/posm.constant";
import SEAOGoodMovementModel from "../../models/retail-asset-management/seao-goods-movement.model";
import ViewBase from "../view-base.view";

const isHQOrRHQ = (vendor) => {
  return vendor === 'HQ' || vendor === 'RHQ'
}

function CreateSEAOPOSMGoodsReceiveDialog() {
  ViewBase.call(this);

  const DEFAULT_MOVEMENT_DETAIL_INFO = {
    movementTypeCode: 'GR',
    movementTypeName: 'Goods Receive',
    movementControlCode: null,
    movementDate: null,
    mainName: null,
    mainCode: null,
    goodsTypeName: null,
    goodsTypeCode: null,
    divisionName: null,
    divisionCode: null,
    modelName: null,
    basicModelId: null,
    basicModelName: null,
    movementQty: 0,
    stockQty: 0,
    mvgPrice: 0,
    refNo: null,
    fromVendor: null,
    fromVendorId: null,
    fromWarehouse: null,
    fromWarehouseId: null,
    fromStorageId: null,
    fromStorage: null,
    channelCode: null,
    channelName: null,
    unitPrice: 0,
    toWarehouseId: null,
    toWarehouse: null,
    toStorageId: null,
    toStorage: null,
    remarks: null,
    fromStockQty: 0,
    toStockQty: 0,
    channelStockQty: 0,
    fileId1: null,
    fileName1: null,
    fileId2: null,
    fileName2: null,
    fileId3: null,
    fileName3: null,
    fileId4: null,
    fileName4: null,
    fileId5: null,
    fileName5: null,
    editQtyYN: null,
    createdDate: null,
    writtenBy: null,
    writtenByName: null,
    movementBy: null,
    movementByName: null,
    gaId: null,
  }

  const CREATE_GOODS_MOVEMENT_FORM_ID = 'CreateGoodsMovementForm'

  let movementDetailInfo = structuredClone(DEFAULT_MOVEMENT_DETAIL_INFO);
  let fileInputs = {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
  }

  let resultSerialList = [];
  const getGoodsMovementHeader = (payload) => {

    this.showLoading();

    SEAOGoodMovementModel.getGoodsMovementHeader(payload)
      .then((result) => {
        Object.assign(movementDetailInfo, {
          mainName: result.mainName,
          mainCode: result.mainId,
          basicModelId: result.basicModelId,
          basicModelName: result.basicModelName,
          divisionCode: result.divisionId,
          divisionName: result.divisionName,
          goodsTypeCode: result.goodsTypeId,
          goodsTypeName: result.goodsTypeName,
          modelName: result.modelName,
          stockQty: result.stockQty,
          toStorage: result.storageLocationName,
          toStockQty: result.storageLocationQty,
          toWarehouse: result.warehouseName,
          toWarehouseId: SEAOGoodMovementModel.movementDetail.warehouse?.code,
          editQtyYN: 'Y',
          writtenByName: loginModel.credentials.username,
          createdDate: new Date().toISOString(),
          movementBy: loginModel.credentials.userID,
          movementByName: loginModel.credentials.username,
          movementDate: new Date().toISOString(),
        });
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getGoodsMovementDetail = (movementControlCode, onClose) => {
    this.showLoading();
    SEAOGoodMovementModel.getGoodsMovementDetail({ movementControlCode })
      .then((result) => {
        if (result != null) {
          movementDetailInfo = result[0];
        } else {
          let labelString = this.getText('EM00000834', 'Movement ID: ${$.movementControlCode} does not exist.');
          labelString = labelString.replace('${$.movementControlCode}', movementControlCode)

          this.showErrorMessage(labelString, '', () => { onClose(true) })
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const buildCreateMovementBody = () => {
    const payload = {
      movementType: 'GR',
      basicModelId: movementDetailInfo.basicModelId,
      fromVendor: movementDetailInfo.fromVendor,
      toStorageCode: SEAOGoodMovementModel.movementDetail.storageLocation?.code,
      qty: movementDetailInfo.movementQty,
      unitPrice: movementDetailInfo.unitPrice,
      refNo: movementDetailInfo.refNo,
      movementDate: moment(movementDetailInfo.movementDate).format(formats.apiDateFormat),
      movementBy: movementDetailInfo.movementBy,
      remarks: movementDetailInfo.remarks,
      fileInput1: fileInputs[1],
      fileInput2: fileInputs[2],
      fileInput3: fileInputs[3],
      fileInput4: fileInputs[4],
      fileInput5: fileInputs[5]
    }
    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value || value == 0) {
        payloadFormData.append(key, value)
      }
    })

    return payloadFormData
  }
  const manualValidate = () => {
    //For Movement Qty
    if (Number(movementDetailInfo.movementQty) == 0) {
      return false;
    }

    //For Unit Price
    if (!isHQOrRHQ(movementDetailInfo.fromVendor) && Number(movementDetailInfo.unitPrice) == 0) {
      return false
    }

    return true;
  }

  const handleSubmit = (e, onClose) => {
    if (!this.validateForm(e)) {
      return
    }

    if (!manualValidate()) {
      return
    }

    this.showLoading();
    SEAOGoodMovementModel.addGoodsMovement(buildCreateMovementBody())
      .then((result) => {
        if (result.transStatus === 'SUCCESS') {
          if (result.serialNumbers?.length) {
            resultSerialList = result.serialNumbers
          }
          else {
            this.showMessage(this.getText("LT00001018", "Item added successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
          }
        } else this.showErrorMessage(result.code ?? result.message, this.getText("EM00000142", "Error"))
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
    // }
  }

  const downloadProofFile = (fileId, fileName) => {
    SEAOGoodMovementModel.downloadProofFile(fileId, fileName)
  }

  const handleChange = (key, value) => {
    movementDetailInfo[key] = value
  }

  let movementControlCode = ''

  const isOpenDetail = () => {
    if (movementControlCode) return true;
    return false;
  }

  const handleDeleteMovement = (onClose) => {
    this.showLoading();

    SEAOGoodMovementModel.deleteGoodsMovement(movementControlCode)
      .then((result) => {
        if (result.transStatus === 'SUCCESS') {
          this.showMessage(this.getText("LT00001077", "Item deleted successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
        } else this.showErrorMessage(result.message, this.getText("EM00000142", "Error"))
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const generateDialogTitle = () => {
    if (isOpenDetail()) {
      return `Goods Receive (${movementControlCode})`
    } else return `${this.getText('LT00000058', 'Create')} Goods Receive`
  }


  const onDownloadSerialClick = () => {
    this.showLoading();
    SEAOGoodMovementModel.downloadSerialNumbersExcel(resultSerialList, 'Serial_Number_List_' + moment().format(formats.LOCAL_TIME) + '.xlsx')
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  return {
    oninit: (vnode) => {
      handleChange('movementTypeCode', SEAOGoodMovementModel.movementDetail.movementType?.code)
      handleChange('movementTypeName', SEAOGoodMovementModel.movementDetail.movementType?.name)
      movementControlCode = vnode.attrs.movementControlCode;

      if (isOpenDetail()) {
        getGoodsMovementDetail(movementControlCode, vnode.attrs.onClose)
      }
      else {
        getGoodsMovementHeader({
          basicModelId: SEAOGoodMovementModel.movementDetail.basicModel?.id,
          storageCode: SEAOGoodMovementModel.movementDetail.storageLocation?.code
        });
      }
    },
    view: ({ attrs: { isOpen, onClose } }) => {
      return [m(Dialog, {
        isOpen,
        onClose,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        class: 'cui-dialog-xxl',
        title: generateDialogTitle(),
        content: [
          m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', {
                id: CREATE_GOODS_MOVEMENT_FORM_ID,
                onsubmit: (e) => { handleSubmit(e, onClose) }
              },
                m('.row.g-2',
                  m('.col-md-4',
                    m('label.form-label[for="main"]',
                      this.getText('LT00000233', 'Division')
                    ),
                    m(`input#Main.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.mainName,
                        title: movementDetailInfo.mainName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="goodsType"]',
                      this.getText('LT00001286', 'Asset Category')
                    ),
                    m(`input#goodsType.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.goodsTypeName + (movementDetailInfo.goodsTypeCode ? `(${movementDetailInfo.goodsTypeCode})` : ''),
                        title: movementDetailInfo.goodsTypeName + (movementDetailInfo.goodsTypeCode ? `(${movementDetailInfo.goodsTypeCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="division"]',
                      this.getText('LT00001287', 'Asset Type')
                    ),
                    m(`input#division.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.divisionName + (movementDetailInfo.divisionCode ? `(${movementDetailInfo.divisionCode})` : ''),
                        title: movementDetailInfo.divisionName + (movementDetailInfo.divisionCode ? `(${movementDetailInfo.divisionCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="model"]',
                      this.getText('LT00001288', 'Item Type')
                    ),
                    m(`input#model.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.modelName,
                        title: movementDetailInfo.modelName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="basicModel"]',
                      this.getText('LT00001218', 'Item Name')
                    ),
                    m(`input#basicModel.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.basicModelName,
                        title: movementDetailInfo.basicModelName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="totalQty"]',
                      this.getText('LT00001273', 'Total Qty')
                    ),
                    m(`input#totalQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.stockQty
                      }
                    )
                  ),

                  m('.col-md-4',
                    m('label.form-label[for="warehouse"]',
                      this.getText('LT00001269', 'Warehouse')
                    ),
                    m(`input#warehouse.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.toWarehouse,
                        title: movementDetailInfo.toWarehouse
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageLocation"]',
                      this.getText('LT00001270', 'Storage Location')
                    ),
                    m(`input#storageLocation.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.toStorage,
                        title: movementDetailInfo.toStorage
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageQty"]',
                      this.getText('LT00001277', 'Storage Qty')
                    ),
                    m(`input#storageQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.toStockQty,
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="writtenBy"]',
                      this.getText('LT00001278', 'Written By')
                    ),
                    m(`input#writtenBy.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.writtenByName,
                        title: movementDetailInfo.writtenByName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="writtenDate"]',
                      this.getText('LT00001285', 'Written Date')
                    ),
                    m(`input#writtenDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.createdDate ? moment(movementDetailInfo.createdDate).format(formats.dateFormat) : '',
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="refNo"]',
                      this.getText('LT00001279', 'Ref No')
                    ),
                    m(`input#refNo.form-control.form-control-bg[type=text]`,
                      {
                        placeholder: this.getText('LT00001279', 'Ref No'),
                        disabled: isOpenDetail(),
                        value: movementDetailInfo.refNo,
                        maxlength: 50,
                        onchange: (e) => {
                          handleChange('refNo', e.target.value)
                        }
                      }
                    )
                  )
                ),
                m('.row.g-2',
                  m('.col-md-4.position-relative',
                    m('label.form-label[for="movementBy"]',
                      this.getText('LT00001280', 'Receive By')
                    ),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      disabled: isOpenDetail(),
                      multiple: false,
                      onSelect: (selectedUserList) => {
                        handleChange('movementBy', selectedUserList[0].userID);
                        handleChange('movementByName', selectedUserList[0].userName);

                      },
                      selectedUserList: [{
                        userID: movementDetailInfo.movementBy,
                        userName: movementDetailInfo.movementByName
                      }],
                    })
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="movementDate"]',
                      this.getText('LT00001281', 'Receive Date')
                    ),
                    !isOpenDetail()
                      ? m(DatePickerComponent, {
                        class: 'form-control',

                        required: true,
                        readonly: true,
                        date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                        onselect: (e) => {
                          handleChange('movementDate', moment(e.detail.date).toISOString());
                        }
                      })
                      : m(`input.form-control.form-control-bg.text-truncate[type=text]`,
                        {
                          disabled: true,
                          value: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                        }
                      ),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  )
                ),
                m('.row.g-2',
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="fromVendor"]',
                      this.getText('LT00001088', 'Vendor')
                    ),
                    m(SelectCommonSearchInputComponent, {
                      disabled: isOpenDetail(),
                      required: true,
                      dataType: COMMON_SEARCH_DATA_TYPES.VENDOR,
                      selectedItem: { code: movementDetailInfo.fromVendorId, name: movementDetailInfo.fromVendor },
                      onSelect: (selectedItem) => {
                        handleChange('fromVendor', selectedItem.name);
                        handleChange('fromVendorId', selectedItem.code);
                        if (isHQOrRHQ(movementDetailInfo.fromVendor)) {
                          handleChange('unitPrice', 0);
                        }
                      },
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  )
                ),
                m('.row.g-2',
                  m('.col-md-6.position-relative',
                    m('label.form-label[for="unitPrice"]', {
                      class: !isHQOrRHQ(movementDetailInfo.fromVendor) ? 'mandatory' : ''
                    }, this.getText('LT00001282', 'Unit Price')),
                    m(DecimalNumbeInputComponent, {
                      required: !isHQOrRHQ(movementDetailInfo.fromVendor),
                      disabled: isHQOrRHQ(movementDetailInfo.fromVendor) || isOpenDetail(),
                      value: movementDetailInfo.unitPrice,
                      onChange: (value) => {
                        if (isHQOrRHQ(movementDetailInfo.fromVendor)) {
                          handleChange('unitPrice', 0);
                          return
                        }
                        handleChange('unitPrice', value)
                      }
                    })
                  )
                ),
                m('.row.g-2',
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="qty"]',
                      this.getText('LT00001283', 'Qty')
                    ),
                    m(QtyNumberInputComponent, {
                      placeholder: this.getText('LT00001283', 'Qty'),
                      required: true,
                      min: 1,
                      max: DEFAULT_MAX_QTY,
                      disabled: isOpenDetail() || movementDetailInfo.editQtyYN !== 'Y',
                      value: movementDetailInfo.movementQty,
                      onChange: (value) => { handleChange('movementQty', value) },
                    })
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8.position-relative',
                    m('label.form-label.[for="fileInput1"]',
                      { class: !!!movementDetailInfo.fileId1 && 'mandatory' },
                      this.getText('LT00001248', 'Proof 1')
                    ),
                    m(FileUploadInputComponent, {
                      required: !!!movementDetailInfo.fileId1,
                      disabled: movementDetailInfo.fileId1 || isOpenDetail(),
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      requiredInvalidText: this.getText('LT00000729', 'This field is required'),
                      onInput: (uploadedFile) => {
                        fileInputs[1] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId1 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName1,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId1, movementDetailInfo.fileName1)
                        }
                      }, movementDetailInfo.fileName1),
                      !isOpenDetail() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId1', null);
                            handleChange('fileName1', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput2"]',
                      this.getText('LT00001249', 'Proof 2')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId2 || isOpenDetail(),
                      onInput: (uploadedFile) => {
                        fileInputs[2] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId2 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName2,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId2, movementDetailInfo.fileName2)
                        }
                      }, movementDetailInfo.fileName2),
                      !isOpenDetail() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId2', null);
                            handleChange('fileName2', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput3"]',
                      this.getText('LT00001250', 'Proof 3')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId3 || isOpenDetail(),
                      onInput: (uploadedFile) => {
                        fileInputs[3] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId3 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName3,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId3, movementDetailInfo.fileName3)
                        }
                      }, movementDetailInfo.fileName3),
                      !isOpenDetail() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId3', null);
                            handleChange('fileName3', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput4"]',
                      this.getText('LT00001251', 'Proof 4')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId4 || isOpenDetail(),
                      onInput: (uploadedFile) => {
                        fileInputs[4] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId4 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName4,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId4, movementDetailInfo.fileName4)
                        }
                      }, movementDetailInfo.fileName4),
                      !isOpenDetail() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId4', null);
                            handleChange('fileName4', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput5"]',
                      this.getText('LT00001252', 'Proof 5')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId5 || isOpenDetail(),
                      onInput: (uploadedFile) => {
                        fileInputs[5] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId5 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName5,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId5, movementDetailInfo.fileName5)
                        }
                      }, movementDetailInfo.fileName5),
                      !isOpenDetail() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId5', null);
                            handleChange('fileName5', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="remarks"]',
                      this.getText('LT00000152', 'Remarks')
                    ),
                    m(`textarea#remarks.form-control.form-control-bg`,
                      {
                        placeholder: this.getText('LT00000152', 'Remarks'),
                        disabled: isOpenDetail(),
                        maxlength: 1000,
                        value: movementDetailInfo.remarks,
                        onchange: (e) => { handleChange('remarks', e.target.value) }
                      }
                    )
                  )
                )
              )
            )
          ),
          this.getBaseViews()
        ],

        footer: m('.row',
          m('.col-12.gap-2.d-flex.justify-content-end',
            !isOpenDetail() &&
            m('button.btn.btn-primary',
              {
                type: 'submit',
                form: CREATE_GOODS_MOVEMENT_FORM_ID
              },
              this.getText('LT00000022', 'Save')
            ),
            m('button.btn.btn-white',
              {
                type: 'button',
                onclick: onClose,
              },
              this.getText('LT00000021', 'Close')
            )
          )
        ),
      }),
      m(Dialog, {
        isOpen: resultSerialList.length > 0,
        onClose: () => { resultSerialList = [] },
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        class: 'cui-dialog-lg',
        title: this.getText('LT00001336', 'Create Success'),
        content: m('.card',
          m('.card-body',
            m('.row',
              m('.col-12',
                this.getText('LT00001337', 'Created Serial Number')
              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table.table-hover',
                    m('thead',
                      m('tr.align-middle',
                        m('th[scope="col"]', this.getText('LT00001338', 'Serial Number')),
                      )
                    ),
                    m('tbody',
                      (resultSerialList.length == 0) &&
                      m('tr.align-middle',
                        m('td[colSpan=13]', this.getText("EM00000141", "No records found."))
                      ),
                      resultSerialList.length > 0 &&
                      resultSerialList.map(({ serialNumber }) =>
                        m('tr.align-middle',
                          m('td', m('span.cursor-text', serialNumber)),
                        )
                      )
                    )
                  )
                )
              ),
            )
          )
        ),
        footer: m('.row',
          m('.col-12.gap-2.d-flex.justify-content-end',
            m('a.btn.btn-primary',
              {
                onclick: () => {
                  onDownloadSerialClick(resultSerialList)
                }
              }, m('i.bi.bi-file-earmark-arrow-down-fill')
              , this.getText("LT00000018", "Excel Download"),
            ),
            m('button.btn.btn-white',
              {
                type: 'button',
                onclick: () => {
                  resultSerialList = [];
                  onClose(true);
                }
              },
              this.getText('LT00000021', 'Close')
            )
          )
        )
      })]
    }
  }
}
export default CreateSEAOPOSMGoodsReceiveDialog